var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ],
      staticClass: "work-list"
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title", staticStyle: { position: "relative" } },
        [
          _c("div", [_vm._v("售后工单商品列表")]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { position: "absolute", right: "0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.redireToWork }
                },
                [_vm._v("\n        客服工单")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询条件")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px 0" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { model: _vm.form, "label-width": "100px" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "输入搜索：" } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _vm.address
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "地区"
                                                    },
                                                    model: {
                                                      value: _vm.form.city,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "city",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.city"
                                                    }
                                                  },
                                                  _vm._l(_vm.address, function(
                                                    item1
                                                  ) {
                                                    return _c("el-option", {
                                                      key: item1.key,
                                                      attrs: {
                                                        label: item1.label,
                                                        value: item1.key
                                                      }
                                                    })
                                                  }),
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _vm.searchOptions
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "搜索内容"
                                                    },
                                                    on: {
                                                      change: _vm.getKeyWord
                                                    },
                                                    model: {
                                                      value: _vm.key_word,
                                                      callback: function($$v) {
                                                        _vm.key_word = $$v
                                                      },
                                                      expression: "key_word"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.selectChooseList,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.key,
                                                        attrs: {
                                                          label: item.text,
                                                          value: item.key
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              "margin-left": "-10px",
                                              width: "200px"
                                            },
                                            attrs: { span: 2 }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "输入搜索内容"
                                              },
                                              model: {
                                                value: _vm.key_content,
                                                callback: function($$v) {
                                                  _vm.key_content = $$v
                                                },
                                                expression: "key_content"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _vm.searchOptions
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "工单状态"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.handle_status,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "handle_status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.handle_status"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.searchOptions
                                                        .handle_status,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.key,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.key
                                                          }
                                                        })
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _vm.searchOptions
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "政策类型"
                                                    },
                                                    model: {
                                                      value: _vm.form.policy,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "policy",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.policy"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.searchOptions.policy,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.key,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.key
                                                          }
                                                        })
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _vm.searchOptions
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "工单类型"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.handle_type,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "handle_type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.handle_type"
                                                    }
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "全部",
                                                        value: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.searchOptions
                                                        .handle_type,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.key,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.key
                                                          }
                                                        })
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "是否子工单"
                                                },
                                                model: {
                                                  value: _vm.form.is_son_order,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "is_son_order",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.is_son_order"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "全部",
                                                    value: "0"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "是",
                                                    value: "1"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "否",
                                                    value: "2"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 7 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "登记时间：" }
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  attrs: {
                                                    type: "datetimerange",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    "default-time": [
                                                      "06:00:00",
                                                      "06:00:00"
                                                    ],
                                                    "range-separator": "至",
                                                    "start-placeholder":
                                                      "开始日期",
                                                    "end-placeholder":
                                                      "结束日期"
                                                  },
                                                  model: {
                                                    value: _vm.form.create_time,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "create_time",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.create_time"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-col", { attrs: { span: 1 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "_ctrl-item" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: { click: _vm.search }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          查询"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: { click: _vm.showSearch }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-arrow-down"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.show_search
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商品名称" },
                                          model: {
                                            value: _vm.form.goods_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "sku" },
                                          model: {
                                            value: _vm.form.sku,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "sku", $$v)
                                            },
                                            expression: "form.sku"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商品款号 " },
                                          model: {
                                            value: _vm.form.goods_kh,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_kh",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_kh"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "颜色 " },
                                          model: {
                                            value: _vm.form.co_val,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "co_val", $$v)
                                            },
                                            expression: "form.co_val"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "尺码" },
                                          model: {
                                            value: _vm.form.si_val,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "si_val", $$v)
                                            },
                                            expression: "form.si_val"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "拆包状态" },
                                            model: {
                                              value: _vm.form.unpack_status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "unpack_status",
                                                  $$v
                                                )
                                              },
                                              expression: "form.unpack_status"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions &&
                                                _vm.searchOptions.unpack_status,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { margin: "0 0 10px 25px" }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "是否人为次品"
                                            },
                                            model: {
                                              value:
                                                _vm.form.is_artificial_damage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "is_artificial_damage",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.is_artificial_damage"
                                            }
                                          },
                                          _vm._l(
                                            _vm.artificialDamageSearchList,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.text,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "拆包时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "default-time": [
                                          "06:00:00",
                                          "06:00:00"
                                        ],
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.chaibao_time,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "chaibao_time",
                                            $$v
                                          )
                                        },
                                        expression: "form.chaibao_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "寄出时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "default-time": [
                                          "06:00:00",
                                          "06:00:00"
                                        ],
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.send_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "send_time", $$v)
                                        },
                                        expression: "form.send_time"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center",
                  position: "relative"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { position: "absolute", right: "0" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "20px"
                        },
                        attrs: {
                          action: _vm.action,
                          name: "file",
                          "on-success": _vm.importSuccess,
                          "on-error": _vm.importError,
                          "show-file-list": false,
                          "with-credentials": ""
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "small", type: "primary" } },
                          [_vm._v("\n              导入用户寄回物流信息")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "id",
                            label: "工单ID",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "imgs",
                            label: "商品图片",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.imgs.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "70px"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: {
                                                src: scope.row.goods_img
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showImages(
                                                    scope.row.imgs
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2150993945
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_id",
                            label: "颜色/尺码/件数",
                            align: "center",
                            width: "130"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.co_val) +
                                        "/ " +
                                        _vm._s(scope.row.si_val) +
                                        "/\n              " +
                                        _vm._s(scope.row.num) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2571774927
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sku",
                            label: "sku",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "发货地", prop: "goods_lib_origin" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "add_time",
                            label: "生成时间",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "user_id",
                            label: "用户id",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "service_order_policy",
                            label: "政策类型",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "service_order_handle_type",
                            label: "工单类型",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "is_son_order",
                            label: "是否子工单",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_sn",
                            label: "订单号",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "order_sn_style",
                                        on: {
                                          click: function($event) {
                                            return _vm.redireToOrder(
                                              scope.row.order_id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.order_sn))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            651122287
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "first_problem",
                            label: "一级问题",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "second_problem",
                            label: "二级问题",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refund_reason",
                            label: "寄回原因",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "problem_desc",
                            label: "问题描述",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "kf_remark",
                            label: "客服备注",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "service_order_handle_status",
                            label: "工单状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "是否人为",
                            "show-overflow-tooltip": "",
                            align: "center",
                            prop: "so_is_artificial_damage_text"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "back_time",
                            label: "拆包时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "c_num",
                            label: "已拆数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "c_status",
                            label: "拆包状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.abnormal_status != 2
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(scope.row.c_status) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.abnormal_status == 2
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.c_status) +
                                              "\n              "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2264486849
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "service_order_ext_cb_has_shipping_num",
                            label: "拆包时是否已绑定运单",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "back_shipping_num",
                            label: "用户寄回运单号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "shipping_nums",
                            label: "仓库拆包寄回运单号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "admin_name",
                            label: "拆包人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dbids",
                            label: "打标id",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dbid_note",
                            label: "拆包备注",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owe_num",
                            label: "不良品数量",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "allot_num",
                            label: "配货数量",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "shipped_num",
                            label: "发货数量",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "out_shipping_num",
                            label: "寄出运单号",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "120"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.show_ship(
                                              scope.row.out_shipping_num
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.out_shipping_num)
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3164934444
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "out_shipping_time",
                            label: "寄出时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "out_shipping_time",
                            label: "日志",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showLogList(scope.row.id)
                                          }
                                        }
                                      },
                                      [_vm._v("\n                查看")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            153983339
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.handle_type_index != 2
                                      ? _c("div", [
                                          scope.row.handle_status_index != 1 &&
                                          scope.row.handle_status_index != 0 &&
                                          scope.row.handle_status_index != 7 &&
                                          scope.row.handle_status_index != 8
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleEdit(
                                                            scope.row.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      scope.row
                                                        .handle_type_index == 1
                                                        ? _c("span", [
                                                            _vm._v("编辑")
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      scope.row
                                                        .handle_type_index == 5
                                                        ? _c("span", [
                                                            _vm._v("查看")
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.handle_status_index == 7 ||
                                          scope.row.handle_status_index == 8
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleEdit(
                                                            scope.row.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    查看\n                  "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.handle_status_index == 3
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.doSendBf(
                                                      scope.row.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  补发寄出\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            141309892
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.showEdit
        ? _c(
            "div",
            [
              _c("cb-address-info", {
                attrs: { work_id: _vm.work_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLog
        ? _c(
            "div",
            [
              _c("work-log", {
                attrs: { work_id: _vm.work_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sendBf
        ? _c(
            "div",
            [
              _c("send-bf", {
                attrs: { work_id: _vm.work_id },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { imgs: _vm.images, show: _vm.showbox },
        on: {
          closeBox: function($event) {
            return _vm.closeBox()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b37b259", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b37b259","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/WorkList.vue
// module id = null
// module chunks = 